import { GET_EMPLOYEES } from "./types";
import { PaginationRequestType } from "@type/HRM/pagination";
import { EmployeesResponseType } from "@type/HRM/employees";

export const getEmployeesRequest = (payload: PaginationRequestType) => {
  return {
    type: GET_EMPLOYEES.GET_EMPLOYEES_REQUEST,
    payload: { payload },
  } as const;
};

export const getEmployeesSuccess = (data: EmployeesResponseType) => {
  return {
    type: GET_EMPLOYEES.GET_EMPLOYEES_SUCCESS,
    payload: { data },
  } as const;
};

export const getEmployeesFailed = () => {
  return {
    type: GET_EMPLOYEES.GET_EMPLOYEES_FAILED,
  } as const;
};

export type EmployeesActions =
  | ReturnType<typeof getEmployeesRequest>
  | ReturnType<typeof getEmployeesSuccess>
  | ReturnType<typeof getEmployeesFailed>;
